<div class="header-title">
  <div class="container-banner">
    <img class="title-image" src="../../../assets/profile-menu/BannerTransferenciadepuntos.png" alt="" />
  </div>
</div>

<div class="section">
  <div class="conversor-info">
    <div class="text-container">
      <h4>¿Cómo hago para transferir?</h4>
      <p>
        Primero escribí el DNI o email de tu destinatario para validar que esté
        registrado en Shell Box. Luego escribí cuántos puntos querés enviarle y
        seleccioná el botón “Transferir Ahora”.
      </p>
      <h4>¿Hay algún límite para transferir?</h4>
      <p>
        ¡Sí! Ese límite lo podés ver debajo de los puntos que querés transferir,
        el cual va a depender de cuántos puntos tengas, o de un límite mensual
        de transferencias.
      </p>
    </div>
  </div>
  <div class="conversor">
    <div class="cardsTransfer">
      <div class="firstCard">
        <div class="searchCard">
          <p>Para comenzar, buscá el destinatario utilizando su DNI o EMAIL</p>
          <div class="card-50">
            <form [formGroup]="transferForm">
              <input (input)="handleSearch()" placeholder="Buscar.." formControlName="inputValue" />
            </form>
          </div>
        </div>
        <p class="participate" *ngIf="
            !destinatarioNoExiste && destinatario !== '' && !selfTransference
          ">
          Tus puntos se transferirán a <strong>{{ destinatario }}</strong>.
        </p>
        <div class="notParticipate" *ngIf="
            destinatarioNoExiste && transferForm.get('inputValue')?.value !== ''
          ">
          <img src="../../../assets/images/icono.jpeg" />
          <p>El destinatario aún no participa del programa Shell Box.</p>
        </div>
        <div class="notParticipate" *ngIf="
            selfTransference &&
            !destinatarioNoExiste &&
            transferForm.get('inputValue')?.value !== ''
          ">
          <img src="../../../assets/images/icono.jpeg" />
          <p>No podés transferir a tu misma cuenta de Shell Box.</p>
        </div>
      </div>
      <div class="cardPoints">
        <div class="card">
          <div class="sendPoints">
            <img [src]="assetUrl('assets/images/logo-borde-gris.svg')" />
            <p>Escribí cuántos puntos querés enviar</p>
          </div>
          <div class="card-50">
            <div class="transferPoints">
              <form [formGroup]="transferForm">
                <input class="inpPoints" type="number" placeholder="0" min="0" [disabled]="transferButtonDisabled"
                  formControlName="pointsValue" (input)="handleValue()" />
              </form>
              <p>Puntos</p>
            </div>
            <p class="remain-points">
              Tenés disponible para transferir este mes
              <span class="header_puntos">{{ userBalance }}</span> puntos Shell
              Box.
            </p>
          </div>
        </div>
        <div class="noPoints" *ngIf="insufficientPoints">
          <img src="../../../assets/images/icono.jpeg" />
          <p>No tenés puntos suficientes para transferir.</p>
        </div>
      </div>
    </div>

    <app-spinner *ngIf="loading"></app-spinner>

    <div class="modal-main-container" *ngIf="showTransferModal">
      <div class="modal-card">
        <button (click)="closeModal()" class="btn-close"></button>
        <app-transfer-blocked-component *ngIf="isBlocked" (close)="closeModal()"></app-transfer-blocked-component>
        <ng-container *ngIf="showConfirmationPopup">
          <app-transfer-code-confirmation
            *ngIf="!isBlocked"
            [form]="form"
            [validationForm]="validationForm"
            [countdown]="countdown"
            [inputControls]="inputControls"
            [destinatario]="destinatario"
            [transferForm]="transferForm"
            [loading]="loading"
            [transferSuccess]="transferSuccess"
            [transferError]="transferError"
            [showError]= "showError"
            [isErrorConfirmed]="isErrorConfirmed"
            [showRevalidate]="showRevalidate"
            (confirm)="confirmCode()"
            (cancel)="cancelTransfer()"
            (resend)="generateCodeForm()"
            (paste)="onPaste($event)"

          >
          </app-transfer-code-confirmation>
        </ng-container>
      </div>
    </div>

    <button type="button" [ngStyle]="{ opacity: transferButtonDisabled ? '0.5' : '1' }" class="transfer-button"
      (click)="transferButtonDisabled ? null : handleTransfer()" [disabled]="transferButtonDisabled">
      TRANSFERIR AHORA
    </button>
  </div>
</div>